module.exports = __webpack_public_path__ + "img/curriculum_down_code.b1dd4345.png";